import React from 'react'
import { FaTrashAlt} from "react-icons/fa";

const EditTableRows = ({rowsData, deleteTableRows, handleChange,handleFabrics}) => {
  return(
      rowsData.map((data, index)=>{
          const {name, qty, unit, price, discount, amount, gst }= data;
          return(
                  <tr key={index+1} mk={name}>
                    <td> 
                        <select required onChange={(evnt)=>(handleChange(index, evnt))} value={`${name}#${price}`} name="name" className="form-control">
                          <option value="">--Select--</option>
                          {handleFabrics.map((fb,i)=>(
                            <option value={fb.id+'#'+fb.price} key={i}>{fb.name}</option>
                          ))}
                        </select>
                      </td>
                    <td><input required type="number" value={qty}  onChange={(evnt)=>(handleChange(index, evnt))} name="qty" className="form-control"/> </td>
                    <td><input type="text" value="Mtr" readOnly  onChange={(evnt)=>(handleChange(index, evnt))} name="unit" className="form-control" /> </td>
                    <td><input required type="number" value={price} readOnly onChange={(evnt)=>(handleChange(index, evnt))} name="price" className="form-control" /> </td>
                    <td><input type="number" value={discount}  onChange={(evnt)=>(handleChange(index, evnt))} name="discount" className="form-control" /> </td>
                    <td><input required type="number" value={amount}  onChange={(evnt)=>(handleChange(index, evnt))} name="amount" className="form-control" /> </td>
                    <td><input type="number" value={gst}  onChange={(evnt)=>(handleChange(index, evnt))} name="gst" className="form-control" /> </td>
                    <td><button className="btn btn-danger" onClick={()=>(deleteTableRows(index))}><FaTrashAlt/></button></td>
                  </tr>
          )
      })
 
  )
  
}

export default EditTableRows;